module.exports = __webpack_public_path__ + "media/images/icons/SVG/027-5acab683d244a052fa54eb0f3d7c0098.svg";